import apiService from '@sonifi/wb-core/services/api.service';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import { cleanFilesSlice, setFile } from '../../store/file/fileSlice';
import { setAlert } from '@sonifi/wb-notifier/store/notifierSlice';
import {
  buildFilesErrorMessage,
  isValidMimeType,
  isValidSize,
} from './fileHelper';
import { ALERTS_IDS } from '@sonifi/wb-notifier/constants/notifierConstants';
import {
  GA_ACTIONS,
  GA_CATEGORIES,
  sendEventGA,
} from '@sonifi/wb-core/services/ga.service';

export const processFiles = ({
  fileList,
  mimeTypes,
  fileExts,
  maxFileSize,
}) => {
  let i;
  const length = fileList.length;
  const files = {
    accepted: [],
    rejected: [],
  };
  let file;
  let validMime;
  let validSize;
  let validName;

  for (i = 0; i < length; i++) {
    file = fileList[i];
    validMime = {
      key: 'invalidType',
      msg: 'The file type is not supported please save and upload in a supported file format',
      valid: isValidMimeType(file, mimeTypes, fileExts),
    };
    validSize = {
      key: 'invalidSize',
      msg: `The file size is bigger than ${maxFileSize / Math.pow(1024, 2)}Mb.`,
      valid: isValidSize(file, maxFileSize),
    };
    validName = {
      key: 'invalidName',
      msg: 'The file name has is not supported characters please save and rename the file.',
      // ONHOLD valid: isValidName(file.name),
      valid: true,
    };

    if (!validMime.valid || !validSize.valid || !validName.valid) {
      files.rejected.push({
        sourceFile: file,
        errors: [validSize, validMime, validName].filter((e) => !e.valid),
      });
    } else {
      files.accepted.push(file);
    }
  }
  return files;
};

export const uploadFiles =
  ({
    alertId,
    files = { accepted: [], rejected: [] },
    autoCleanState = true,
  }) =>
  async (dispatch, getState) => {
    const {
      groups: { selectedGroup },
    } = getState();
    const filesRes = { accepted: [], rejected: [] };

    if (files.rejected.length) {
      const rejectedFilesMessage = buildFilesErrorMessage(files.rejected);

      dispatch(
        setAlert({
          id: alertId || ALERTS_IDS.wbapp,
          content: rejectedFilesMessage,
          type: 'danger',
          show: true,
          dismissable: true,
        }),
      );
    }
    const formData = new FormData();
    formData.append('group', selectedGroup.uri);

    for (const file of files.accepted) {
      dispatch(setFile({ name: file.name, loaded: false }));
      formData.set('embedded_file', file);
      try {
        const fRes = await apiService.post(ENDPOINTS.FILES, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        filesRes.accepted.push({ ...fRes.data, title: file.name });
        dispatch(setFile({ name: file.name, loaded: true }));
        sendEventGA({
          action: GA_ACTIONS.fileUpload,
          category: GA_CATEGORIES.files,
          label: file.type,
        }); // Google Analytics
      } catch (error) {
        console.error(error);
        dispatch(
          setAlert({
            content: `Failed to upload file: ${file.name}`,
            type: 'danger',
            show: true,
            dismissable: true,
          }),
        );
        const fileRejected = { name: file.name, loaded: false };
        filesRes.rejected.push(fileRejected);
        dispatch(setFile(fileRejected));
      }
    }
    autoCleanState && dispatch(cleanFilesSlice());
    return filesRes;
  };

export const proccessAndUploadFiles =
  ({
    alertId,
    files = [],
    options: { mimeTypes, fileExts, maxFileSize, autoCleanState = true },
  }) =>
  async (dispatch) => {
    const filesProcessed = processFiles({
      fileList: files,
      mimeTypes,
      fileExts,
      maxFileSize,
    });

    const fileRes = await dispatch(
      uploadFiles({
        alertId,
        autoCleanState,
        files: filesProcessed,
      }),
    );

    return fileRes;
  };

export const deleteFile = async (fileId) => {
  try {
    await apiService.delete(`${ENDPOINTS.FILES}/${fileId}`);
    return fileId;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
